import { computed, ComputedRef } from 'vue';
import { useStore } from 'vuex';

interface UseDateUtils {
    currentDate: string;
    formatDateDisplayed: ComputedRef<string>;
}

export function useDateUtils(): UseDateUtils {
    const currentDate = moment().format('YYYY-MM-DD');

    const formatDateDisplayed = computed(() => {
        const store = useStore();
        return store.state.corp.timeformat === 'dmy' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
    });

    return { currentDate, formatDateDisplayed };
}
